var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 12.9999C16.4998 12.9999 19.334 10.1657 19.334 6.66654C19.334 3.16737 16.4998 0.333206 13.0007 0.333206C9.50148 0.333206 6.66732 3.16737 6.66732 6.66654C6.66732 10.1657 9.50148 12.9999 13.0007 12.9999ZM13.0007 16.1665C8.77315 16.1665 0.333984 18.2882 0.333984 22.4999V24.0832C0.333984 24.954 1.04648 25.6665 1.91732 25.6665H24.084C24.9548 25.6665 25.6673 24.954 25.6673 24.0832V22.4999C25.6673 18.2882 17.2282 16.1665 13.0007 16.1665Z",
    fill: "#FCBC5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3ded8c07bb3db6cdc08297ad19f20e75.svg";
export { ForwardRef as ReactComponent };